export const LINKS = {
  GRAPHQL: '/graphql',
  CONTENT: '/api/distribution/content',
  CREATE_PROFILE: '/api/distribution/createProfile',
  UPDATE_PROFILE: '/api/distribution/updateProfile',
  ORG_HIERARCHY: 'api/distribution/getAgencyHierarchy',
  PROFILE: '/api/distribution/getProfileByRef',
  AGENTLIST: '/api/distribution/agentlist',
  REMERCHANDISE: '/api/policies/lead',
  POLICY: '/api/policies',
  POLICY_RESEND: '/api/policies/confirmation/resend',
  POLICYPDF: '/api/policies/${policyNumber}/confirmation/pdf',
  POLICYDELIVERY: '/api/policies/${policyNumber}/confirmation/deliveries',
  POLICYHISTORY: '/api/policies/${policyNumber}/history',
  QUOTE: '/api/quote',
  RECOMMENDATION: '/api/recommendation',
  TMS: '/tms/translationspaces/${translationSpace}/translations/${translation}',
  KEEP_ALIVE: '/keepalive',
  AUTH: '/api/auth/token',
  RE_QUOTE: '/api/policies/re-quote',
  POLICY_CANCEL: '/api/policies/cancel',
  POLICY_RETRY: '/api/policies/retry',
  SYNC_QUOTE_FORM: '/sync-quote',
  NOTES: '/api/notes',
  POLICY_SEARCH: '/api/policies/search',
  PRODUCT: '/api/product/orgContract',
  MEDICALQUESTIONNAIRE: '/api/product/medicalQuestionaire',
  DISTRIBUTION: '/api/distribution/list-organization',
  CREATE_AGENT_LICENSE: '/api/distribution/agent/license',
  CREATE_AGENCY_LICENSE: '/api/distribution/agency/license',
  LICENSE_SEARCH: '/api/distribution/licenses/search',
  LICENSE_EXPORT: '/api/distribution/licenses/export',
  AGENCY_LICENSE: '/api/distribution/org',
  AGENT_LICENSE: '/api/distribution/profile',
  EXTRNL_REPORT_ORG_LIST: '/api/distribution/list-organization-reports',
  AGENTS_SEARCH: '/api/distribution/agent/search',
  SEARCH_ORGANIZATION: '/api/distribution/findByOrgCode',
  CREATE_AGENCY: '/api/distribution/agency',
  AGENCY_CREATE_ORGANIZATIONS: '/api/distribution/agency-create/organizations',
  AGENCY_CREATE_COMPENSATION_CODES: '/api/distribution/agency-create/compensation-codes',
  GET_ROLES: '/api/distribution/getRoles',
  RATES_DATA: '/api/product/ratesDropdown',
  UPDATE_AGENCY: '/api/distribution/updateByOrgCode',
  GET_ADVISOR_BY_COUNSELOR_ID: '/api/distribution/advisor/lh/find',
  ALLOCATIONS_DROPDOWN: '/api/product/allocationsdropdown',
  GET_ADVISOR_BY_PARTY_ID: '/api/distribution/advisor/dss/find',
  RATES_UPLOAD: 'api/product/rates/upload',
  CREATE_ADVISOR: '/api/distribution/advisor'
};

export const API_TIME_OUT = 300000 * 1000;
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const TRANSACTION_DATE_FORMAT = 'YYYY-MM-DD h:mma z';

export const MANULIFE_LOGO_LABEL = 'Manulife';
export const MANULIFE_LOGO_LABEL_FRENCH = 'Manuvie';

export const MQ_SCORE = 10;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT = 10;
export const DATE_SUB = 10;
export const PRIMARY = 'Primary';

export const PAYMENT_METHOD_MAPPING = {
  visa: 'VISA',
  mastercard: 'MASTER',
  'american-express': 'AMEX'
};

export const API_KEYS = {
  DEDUCTIBLE: 'DEDUCTIBLE',
  STUB_AGENT_KEY: 'AG1',
  FAMILY: 'FAMILY',
  MULTIPLE: 'MULTIPLE',
  INTERNATIONAL: 'INTERNATIONAL',
  SINGLE: 'SINGLE',
  CANADA: 'CANADA',
  MEDICAL: 'MEDICAL',
  NEEDS_ANALYSIS: 'NEEDS_ANALYSIS',
  CHARGE: 'CHARGE',
  REFUND: 'REFUND'
};
